import React from 'react';
import { Button, Container, Stack, TextInput } from '@mantine/core';
import {
  AiOutlineArrowRight,
  AiOutlineCalendar,
  AiOutlineIdcard,
} from 'react-icons/ai';
import 'dayjs/locale/pt-br';
import { useForm } from '@mantine/form';

interface FormProps {
  assembleiaId: string;
  onSubmit: (data: { cpf: string; data_nasc: string | undefined }) => void;
}

export default function FormNascimento({ onSubmit }: FormProps) {
  const regexValidDate =
    /^(3[01]|[12][0-9]|0?[1-9])(\/|-)(1[0-2]|0?[1-9])\2([0-9]{2})?[0-9]{2}$/;
  const form = useForm({
    initialValues: {
      cpf: '',
      data_nasc: '',
    },
    validate: {
      cpf: (value) => (/^\d{11}$/.test(value) ? null : 'CPF Inválido'),
      data_nasc: (value) =>
        regexValidDate.test(value) ? null : 'Data inválida',
    },
  });
  return (
    <Container>
      <form onSubmit={form.onSubmit(onSubmit)}>
        <Stack>
          <TextInput
            label="CPF (Ex: 07700011122)"
            icon={<AiOutlineIdcard />}
            required
            withAsterisk
            {...form.getInputProps('cpf')}
            size="sm"
          />

          <TextInput
            label="Data de Nascimento (Ex: 01/01/1990)"
            icon={<AiOutlineCalendar />}
            required
            withAsterisk
            {...form.getInputProps('data_nasc')}
          />

          <Button leftIcon={<AiOutlineArrowRight />} type="submit">
            VALIDAR E ACESSAR
          </Button>
        </Stack>
      </form>
    </Container>
  );
}
